import Fetch from './index'
import * as tool from '@/libs/tool'
const BASE_URL = 'https://hrpay.laway.cn/api/speed-front'
const APPID = tool.getAppId()
const axios = new Fetch(BASE_URL, APPID)

export function getAllAreas () {
  // 获取地区的接口
  return axios.request('get', '/area/getQuestionAllArea')
}

export function getLawlist (params) {
  // 获取法律列表
  return axios.request('get', '/law/searchLaw', params)
}

export function getProfessionalList () {
  // 专业列表
  return axios.request('get', '/professional/all', { type: 2 })
}

export function getLaworgs () {
  // 获取发布机构列表
  return axios.request('get', '/law/lawOrgs')
}

export function getLawIndustrys () {
  // 获取行业列表
  return axios.request('get', '/law/lawIndustrys')
}

export function getLawForceLevelInfo () {
  // 获取效力等级信息
  return axios.request('get', '/law/lawForceLevelInfo')
}

export function getLawForceStatusInfo () {
  // 获取效力状态信息
  return axios.request('get', '/law/lawForceStatusInfo')
}

export function getCount () {
  // 获取数量
  return axios.request('get', '/law/count')
}

export function getSearchLawArticle (params) {
  // 法条信息查询
  return axios.request('get', '/law/searchLawArticle', params)
}

export function getLawDetail (id) {
  // 获取法律详情
  let params = {
    id: id
  }
  return axios.request('get', '/law/detail', params)
}

export function getBindPro (level) {
  // 获取绑定的专业列表
  return axios.request('get', `/professional/listByForceLevel/${level}`)
}

export function recomPro (params) {
  // 推荐专业
  return axios.request('get', '/professional/list', params)
}

export function getRecomLaws () {
  // 推荐法律
  return axios.request('get', '/law/getRecommendLaws')
}



// WEBPACK FOOTER //
// ./src/datas/law.js